/**
 * Test IDs for QA automation.
 */
export const testIds = {
  goodsInputAutocomplete: "goods-input-autocomplete",
  goodsInputAutocompleteInput: "goods-input-autocomplete-input",
  goodsInputAutocompleteOption: "goods-input-autocomplete-option",
} as const;
